import { render, staticRenderFns } from "./checkToken.vue?vue&type=template&id=33cebe92&scoped=true&"
import script from "./checkToken.vue?vue&type=script&lang=js&"
export * from "./checkToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cebe92",
  null
  
)

export default component.exports